document.querySelector('.product-form__submit').addEventListener('click', function (e) {
    // Form validation
    const allInputs = {
        customAmount: document.querySelector('#custom-amount'),
        recipientName: document.querySelector('#recipient-name'),
        recipientEmail: document.querySelector('#recipient-email'),
        recipientConfirmEmail: document.querySelector('#recipient-email-confirm'),
        senderName: document.querySelector('#sender-name'),
        greeting: document.querySelector('#greeting'),
        deliveryDate: document.querySelector('#delivery-date')
    };

    const variantElement = document.querySelector('span[data-selected-swatch-value="Delivery"]');
    const variantValue = variantElement ? variantElement.textContent.trim().toLowerCase() : '';

    // Show/clear error
    function showError(input, message, errorSpan) {
        if (!input) return;
        if (errorSpan) {
            errorSpan.textContent = message;
            errorSpan.classList.remove('hidden');
        }
    }

    function clearError(input) {
        if (!input) return;
        const errorSpan = input.parentElement.querySelector('.form-message--error');
        if (errorSpan) {
            errorSpan.textContent = '';
            errorSpan.classList.add('hidden');
        }
    }

    // Scroll to first error field
    function scrollToError(input) {
        if (!input) return;
        const headerHeight = document.querySelector('header')?.offsetHeight || 0;
        const elementPosition = input.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });

        // Focus on the input field
        input.focus();
    }

    //Converts a DD/MM/YYYY date string into a JavaScript Date object.
    function parseAUDate(dateStr) {
        const [day, month, year] = dateStr.split('/');
        return new Date(`${year}-${month}-${day}T00:00:00`);
    }

    // Validation rules
    function validateField(input) {
        if (!input) return true;
        const id = input.getAttribute('id');
        const value = input.value.trim();

        // Custom amount validation
        if (id === 'custom-amount') {
            const errorEl = document.getElementById('form-error-properties-custom-amount');
            const selector = document.querySelector('.gift-card-selector');
            if (!selector) return true;

            const min = parseFloat(selector.dataset.min);
            const max = parseFloat(selector.dataset.max);
            const numericValue = parseFloat(value);

            if (value === '') { clearError(input); }

            // Validation
            if (isNaN(numericValue)) {
                showError(input, 'Please enter a valid amount.', errorEl);
                updateAddToCart(null, false);
                return false;
            } else if (numericValue < min) {
                showError(input, `Amount must be at least ${formatCurrency(min)}`, errorEl);
                updateAddToCart(null, false);
                return false;
            } else if (numericValue > max) {
                showError(input, `Amount cannot exceed ${formatCurrency(max)}`, errorEl);
                updateAddToCart(null, false);
                return false;
            } else {
                clearError(input, errorEl);
                updateAddToCart(numericValue, true);
            }
        }

        if (id === 'greeting') {
            const errorSpan = document.getElementById('form-error-properties-greeting');
            if (value === '') { clearError(input); }
            if (/[^a-zA-Z0-9\s\-!$&().,\/:;?"']/.test(value)) { showError(input, 'Please use alphanumeric characters only.', errorSpan); return false; }
            if (value.length > 150) { showError(input, 'Please enter no more than 150 characters.', errorSpan); return false; }
        }

        if (id === 'recipient-name') {
            const errorSpan = document.getElementById('form-error-properties-recipient-name');
            if (value === '') { clearError(input); }
            if (/[^a-zA-Z0-9\s\-!$&().,\/:;?"']/.test(value)) { showError(input, 'Please use alphanumeric characters only.', errorSpan); return false; }
        }

        if (id === 'sender-name') {
            const errorSpan = document.getElementById('form-error-properties-sender-name');
            if (value === '') { clearError(input); }
            if (/[^a-zA-Z0-9\s\-!$&().,\/:;?"']/.test(value)) { showError(input, 'Please use alphanumeric characters only.', errorSpan); return false; }
        }

        if (id === 'delivery-date') {
            const selectedOption = document.querySelector('input[id="select_date_picker"]:checked');
            const errorSpan = document.getElementById('form-error-properties-delivery-date');

            if (value === '') {
                if (id === 'delivery-date' && variantValue === 'physical') return true;
                showError(input, 'This field is required', errorSpan);
                return false;
            }

            // Validate date format first
            const selectedDate = parseAUDate(value);
            if (!selectedDate || isNaN(selectedDate.getTime())) {
                showError(input, 'The date is invalid. Please enter a date with the format DD/MM/YYYY.', errorSpan);
                return false;
            }

            if (selectedOption && selectedOption.value === 'selected' && value) {
                const todayStr = new Date().toLocaleDateString('en-AU', { timeZone: 'Australia/Sydney' });
                const selectedDate = parseAUDate(value);
                const todayDate = parseAUDate(todayStr);
                if (selectedDate < todayDate) { showError(input, 'Delivery dates must be in the future.', errorSpan); return false; }
            }
        }

        if (id === 'recipient-email') {
            if (value != '') {
                const errorSpan = document.getElementById('form-error-properties-recipient-email');
                const emailRegex = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
                if (!emailRegex.test(value)) { showError(input, 'Please enter a valid email address.', errorSpan); return false; }
            }
        }

        if (id === 'recipient-email-confirm') {
            const errorSpan = document.getElementById('form-error-properties-recipient-confirm-email');
            const emailInput = document.querySelector('#recipient-email');
            const emailValue = emailInput ? emailInput.value.trim() : '';

            if (value != '') {
                const emailRegex = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
                if (!emailRegex.test(value)) { showError(input, 'Please enter a valid email address.', errorSpan); return false; }
                if (emailInput && emailInput.value.trim() !== value) { showError(input, "The emails provided don't match. Please try again.", errorSpan); return false; }
            } else {
                // If email has value but confirm email is empty
                if (emailValue !== '' && value == '') {
                    showError(input, "The emails provided don't match. Please try again.", errorSpan);
                    return false;
                }
            }
        }

        clearError(input);
        return true;
    }

    // Run validation and track first error
    let valid = true;
    let firstErrorField = null;

    Object.values(allInputs).forEach(input => {
        const isValid = validateField(input);
        if (!isValid) {
            valid = false;
            // Capture the first error field only
            if (!firstErrorField && input) {
                firstErrorField = input;
            }
        }
    });

    // Only prevent submission and scroll if there are actual errors
    if (!valid && firstErrorField) {
        e.preventDefault();
        scrollToError(firstErrorField);
    }
});

// When the user types in the custom amount input
function attachCustomAmountListener() {
    const customAmountInput = document.querySelector('#custom-amount');
    if (!customAmountInput) return;

    if (customAmountInput) {
        customAmountInput.addEventListener('input', () => {
            const customInputValue = customAmountInput.value;
            handleAmountChange(customInputValue, false);
        });
    }
}

attachCustomAmountListener();

(function () {
    const GOV_EDU_NOTICE = 'Please note that emails using a .gov or .edu domain have firewalls that can impact the arrival of your Gift Card.';

    function isGovOrEduDomain(email) {
        const atIndex = email.lastIndexOf('@');
        if (atIndex === -1) return false;
        const domain = email.slice(atIndex + 1).toLowerCase();
        return /\.gov(\.|$)|\.edu(\.|$)/.test(domain);
    }

    function checkGovEduNotice(input, noticeSpan) {
        if (!input || !noticeSpan) return;
        const value = input.value.trim();
        if (value !== '' && isGovOrEduDomain(value)) {
            noticeSpan.textContent = GOV_EDU_NOTICE;
            noticeSpan.classList.remove('hidden');
        } else {
            noticeSpan.textContent = '';
            noticeSpan.classList.add('hidden');
        }
    }

    function attachGovEduListeners() {
        const emailInput = document.querySelector('#recipient-email');
        const emailNotice = document.getElementById('form-notice-properties-recipient-email');
        const confirmInput = document.querySelector('#recipient-email-confirm');
        const confirmNotice = document.getElementById('form-notice-properties-recipient-confirm-email');

        if (emailInput && emailNotice) {
            emailInput.addEventListener('input', () => checkGovEduNotice(emailInput, emailNotice));
        }
        if (confirmInput && confirmNotice) {
            confirmInput.addEventListener('input', () => checkGovEduNotice(confirmInput, confirmNotice));
        }
    }

    attachGovEduListeners();
})();

// Live validation: warn the user as soon as the confirm-email field doesn't
// match the recipient email, instead of waiting until "add to bag" is clicked.
(function () {
    const MISMATCH_MESSAGE = "The emails provided don't match. Please try again.";

    function showFieldError(errorSpan, message) {
        if (!errorSpan) return;
        errorSpan.textContent = message;
        errorSpan.classList.remove('hidden');
    }

    function clearFieldError(errorSpan) {
        if (!errorSpan) return;
        errorSpan.textContent = '';
        errorSpan.classList.add('hidden');
    }

    function checkEmailsMatchLive() {
        const emailInput = document.querySelector('#recipient-email');
        const confirmInput = document.querySelector('#recipient-email-confirm');
        const errorSpan = document.getElementById('form-error-properties-recipient-confirm-email');
        if (!confirmInput || !errorSpan) return;

        const emailValue = emailInput ? emailInput.value.trim() : '';
        const confirmValue = confirmInput.value.trim();

        // Nothing typed in the confirm field yet - don't show an error.
        if (confirmValue === '') {
            clearFieldError(errorSpan);
            return;
        }

        // Compare against the recipient email as-typed, character by character,
        // so the customer sees the mismatch immediately rather than only once
        // they've finished typing a full address.
        if (emailValue !== confirmValue) {
            showFieldError(errorSpan, MISMATCH_MESSAGE);
        } else {
            clearFieldError(errorSpan);
        }
    }

    function attachEmailMatchLiveListeners() {
        const emailInput = document.querySelector('#recipient-email');
        const confirmInput = document.querySelector('#recipient-email-confirm');

        if (emailInput) emailInput.addEventListener('input', checkEmailsMatchLive);
        if (confirmInput) confirmInput.addEventListener('input', checkEmailsMatchLive);
    }

    attachEmailMatchLiveListeners();
})();

// When the user clicks a predefined gift card amount button
document.querySelectorAll('.gift-card-amounts button').forEach(btn => {
    btn.addEventListener('click', () => {
        const customInput = document.querySelector('#custom-amount');

        // Update input value
        customInput.value = btn.dataset.amount;
        handleAmountChange(btn.dataset.amount, true);

        // Reset all buttons
        document.querySelectorAll('.gift-card-amounts button').forEach(b => {
            b.classList.add('btn--secondary');
            b.classList.remove('is-active');
        });

        // Add active state to clicked button
        btn.classList.add('btn--secondary', 'is-active');
    });
});

// Handle amount changes
function handleAmountChange(value, fromButton = false) {
    const numericValue = parseFloat(value);
    const selector = document.querySelector('.gift-card-selector');
    const min = parseFloat(selector.dataset.min);
    const max = parseFloat(selector.dataset.max);
    const customInput = document.querySelector('#custom-amount');
    const errorEl = document.querySelector('#form-error-properties-custom-amount');

    // Validation
    if (isNaN(numericValue)) {
        showError(customInput, 'Please enter a valid amount.', errorEl);
        updateAddToCart(null, false);
    } else if (numericValue < min) {
        showError(customInput, `Amount must be at least ${formatCurrency(min)}`, errorEl);
        updateAddToCart(null, false);
    } else if (numericValue > max) {
        showError(customInput, `Amount cannot exceed ${formatCurrency(max)}`, errorEl);
        updateAddToCart(null, false);
    } else {
        clearError(customInput, errorEl);
        updateAddToCart(numericValue, true);
    }
}

function getBaseText() {
    // Store the original button text once
    const addToCartButton = document.querySelector('.product-form__submit span');
    return addToCartButton;
}

// Appends the selected or entered gift card amount to the "Add to Cart" button
function updateAddToCart(value, isValid = true) {
    const addToCartButton = getBaseText();
    const baseText = 'add to bag';
    addToCartButton.textContent = isValid && value
        ? `${baseText} - ${formatCurrency(value)}`
        : baseText;
}

// Show/clear error
function showError(input, message, errorSpan) {
    if (!input) return;
    if (errorSpan) {
        errorSpan.textContent = message;
        errorSpan.classList.remove('hidden');
    }
}

function clearError(input, errorSpan) {
    if (!input) return;

    errorSpan.textContent = '';
    errorSpan.classList.add('hidden');

}

// Currency formatter
function formatCurrency(value) {
    const currencyFormatter = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
    return currencyFormatter.format(parseFloat(value));
}

// Date Picker
function getAESTDateString(date) {
    const aestDate = new Date(
        date.toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
    );
    const day = String(aestDate.getDate()).padStart(2, '0');
    const month = String(aestDate.getMonth() + 1).padStart(2, '0');
    const year = aestDate.getFullYear();
    return `${day}/${month}/${year}`;
}

function updateNotes() {
    const giftcardBlock = document.querySelector('.giftcard-date-picker');
    if (!giftcardBlock) return;
    const todayOption = giftcardBlock.querySelector('input[value="today"]');
    const deliveryDateField = document.querySelector('#delivery-date');
    const todayNote = document.querySelector('.today-label-option');
    const selectedDateNote = document.querySelector('.selected-label-option');
    const today = getAESTDateString(new Date());

    if (todayOption.checked) {
        deliveryDateField.disabled = true;
        deliveryDateField.value = today;
        todayNote.classList.remove('hidden');
        selectedDateNote.classList.add('hidden');
    } else {
        deliveryDateField.disabled = false;
        deliveryDateField.value = '';
        todayNote.classList.add('hidden');
        selectedDateNote.classList.remove('hidden');
    }
}

function showDatePicker(value) {
    if (value !== 'physical') updateNotes();
}

// Event Listeners
document.querySelectorAll('.product-form__input--button-circle input[type="radio"]')
    .forEach(radio => radio.addEventListener('change', () => radio.checked && showDatePicker(radio.value)));

document.querySelectorAll('#today_date_picker, #select_date_picker')
    .forEach(el => el.addEventListener('change', updateNotes));